import { fetchTranslations } from '@ori-appshell/shared';

import type { ITranslationsProviderResponse } from '../models';
import { TranslationKey } from '../models';

export const translationsProvider = async (
    baseUrl: string,
    currentLanguage: string,
): Promise<ITranslationsProviderResponse> => {
    const { translations } = await fetchTranslations({ baseUrl, currentLanguage, keys: TranslationKey });

    return translations ?? {};
};
